










































































import { Component, Prop, Vue } from 'vue-property-decorator'
import DefaultButton from './DefaultButton.vue'
import { ButtonType } from '@/data/enums'

@Component({
  components: {
    DefaultButton
  }
})
export default class NavigationButtons extends Vue {
  @Prop({ default: () => [] }) public disabledButtons?: ButtonType[]
  @Prop() public prev!: string
  @Prop() public next!: string
  @Prop() public extra!: string
}
